import { Routes } from '@angular/router';
import { ScheduleAdminComponent } from './components/schedule-admin/schedule-admin.component';

export const SCHEDULE_ROUTES: Routes = [{
	path: 'Schedule', component: ScheduleAdminComponent
}];
